































import { Component, Mixins, Ref } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import BlueprintsMixin from "@/mixins/http/BlueprintsMixin";
import VNumericInput from "@/components/VNumericInput.vue";
import { NoCache, RegisterHttp } from "../../utils/Decorators";
import FileUploader from "@/components/FileUploader.vue";
import { showToast } from "../../utils/Toast";
import VMultiTuple from "@/components/VMultiTuple.vue";
import VTuple from "@/components/VTuple.vue";
import VContentLoading from "@/components/VContentLoading.vue";
import BlueprintFields from "./Fields.vue";

import { BlueprintMetadata } from "../../models/Blueprint";
import RequestData from "@/store/types/RequestData";
const createTag = "createTag";

@Component({
  components: {
    VModal,
    VNumericInput,
    VTuple,
    VMultiTuple,
    FileUploader,
    VContentLoading,
    BlueprintFields,
  },
})
export default class BlueprintCreateModal extends Mixins(BlueprintsMixin) {
  @Ref() readonly modal!: VModal;
  @RegisterHttp(createTag) readonly http!: RequestData;

  private prototype: any = {
    name: null,
    blueprint: null,
    metadata: BlueprintMetadata.empty(),
  };

  onDetachFile() {
    this.prototype.blueprint = null;
  }

  onFileAdded(file) {
    this.$nextTick(() => {
      if (!file.name.endsWith("obj")) {
        this.prototype.blueprint = null;
      } else {
        this.prototype.blueprint = file;
      }
    });
  }

  canceled!: Function | null;

  @NoCache
  get valid() {
    const baseValid = this.prototype.name && this.prototype.blueprint;
    return baseValid;
  }

  title() {
    return `Add Blueprint`;
  }

  protected onCancel() {
    if (this.canceled) {
      this.canceled();
    }

    this.canceled = null;
    this.modal.hide();
    this.reset();
  }

  protected async onConfirm() {
    const formData = new FormData();
    formData.append("name", this.prototype.name);
    formData.append("metadata", JSON.stringify(this.prototype.metadata));

    if (this.prototype.blueprint) {
      formData.append("blueprint", this.prototype.blueprint.file);
    }
    this.createBlueprint(formData, createTag).then(
      (resp) => {
        this.$emit("confirmed", resp);
        this.modal.hide();
        this.reset();
        showToast(`Blueprint created successfully`);
      },
      (err) => {
        showToast(err?.response?.data?.message || err.message, {
          type: "error",
        });
      }
    );
  }

  protected onHidden() {
    if (this.canceled) {
      this.canceled();
    }
  }

  reset() {
    this.prototype = {
      name: null,
      metadata: BlueprintMetadata.empty(),
      blueprint: null,
    };
  }

  create() {
    this.modal.show();
  }
}
